import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, Divider } from 'antd';
import { UserOutlined, LockOutlined, UserAddOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const { Title, Text } = Typography;

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  const onFinish = async (values: { email: string; password: string }) => {
    try {
      setLoading(true);
      await login(values.email, values.password);
      // Small delay to ensure state is updated
      await new Promise(resolve => setTimeout(resolve, 100));
      navigate('/dashboard');
    } catch (error: any) {
      console.error('Login error:', error);
      // Error already shown by login function
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      }}
    >
      <Card
        style={{
          width: 400,
          boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
          borderRadius: 16,
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>🛍️</div>
          <Title level={2} style={{ marginBottom: 8 }}>
            Fashion Connect
          </Title>
          <Text type="secondary">Dashboard Giriş</Text>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Lütfen email adresinizi girin!' },
              { type: 'email', message: 'Geçerli bir email adresi girin!' },
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="Email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: 'Lütfen şifrenizi girin!' },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Şifre"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              style={{ height: 48, fontSize: 16, fontWeight: 500 }}
            >
              Giriş Yap
            </Button>
          </Form.Item>

          <Divider style={{ margin: '16px 0' }}>
            <Text type="secondary" style={{ fontSize: 12 }}>veya</Text>
          </Divider>

          <Link to="/register">
            <Button
              block
              icon={<UserAddOutlined />}
              style={{ 
                height: 48, 
                fontSize: 14,
                borderColor: '#52c41a',
                color: '#52c41a',
              }}
            >
              Yeni Marka Kaydı Oluştur
            </Button>
          </Link>

          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              Fashion Connect Dashboard v1.0
            </Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default Login;

